import { render, staticRenderFns } from "./EditStatisticBoardModal.vue?vue&type=template&id=797efb2c&scoped=true"
import script from "./EditStatisticBoardModal.ts?vue&type=script&lang=ts&external"
export * from "./EditStatisticBoardModal.ts?vue&type=script&lang=ts&external"
import style0 from "./EditStatisticBoardModal.scss?vue&type=style&index=0&id=797efb2c&prod&lang=scss&scoped=true&external"
import style1 from "./EditStatisticBoardModal.vue?vue&type=style&index=1&id=797efb2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797efb2c",
  null
  
)

export default component.exports